exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#about{width:860px;margin-left:auto;margin-right:auto;color:#fff;background-color:rgba(3,3,3,.3);padding:20px;border-radius:10px}#about .main{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/styles/about.scss
// module id = 2
// module chunks = 0